import { ALL_AUDIENCE } from '@/domain/types/audience';
import { audienceIdsForPublication } from '@/domain/use-cases/audiences/membership-rules';
import { serverTimestamp } from 'firebase/firestore';

export type ReleaseAdmin = { id: string; name: string; email: string };

/**
 * ¿Este guardado libera una publicación restringida al público?
 * previous son los audienceIds actuales; selected es lo elegido en el formulario.
 */
export function isReleasingToAll(
  previousAudienceIds: string[] | undefined,
  selectedAudiences: string[],
): boolean {
  const wasRestricted =
    Array.isArray(previousAudienceIds) &&
    previousAudienceIds.length > 0 &&
    !previousAudienceIds.includes(ALL_AUDIENCE);
  const willBePublic = selectedAudiences.length === 0;
  return wasRestricted && willBePublic;
}

/**
 * Construye el payload de la actualización.
 *
 * CRÍTICO: audienceIds, releasedToAllAt y releasedToAllBy deben ir en un ÚNICO
 * updateDoc. Si se parten en dos escrituras, el trigger releasesAudienceRelease
 * se dispara dos veces y la segunda todavía ve before.releasedToAllAt indefinido,
 * es decir, un push duplicado a toda la plataforma.
 */
export function buildReleaseToAllPayload(
  selectedAudiences: string[],
  admin: ReleaseAdmin,
): Record<string, unknown> {
  const audienceIds = audienceIdsForPublication(selectedAudiences);
  const payload: Record<string, unknown> = { audienceIds };

  if (selectedAudiences.length === 0) {
    payload.releasedToAllAt = serverTimestamp();
    payload.releasedToAllBy = admin;
  }

  return payload;
}
